<template>
  <div>
    <div class="row">
      <div class="col-8 offset-2">
        <div class="my-3">
          <campaign-id-search
            @on-campaign-found="handleCampaignFound"
            @on-search="handleOnSearch"
          ></campaign-id-search>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8 offset-2">
        <campaign-display
          v-if="campaign"
          :id="campaign.id"
          :displayName="campaign.displayName"
          :agency="campaign.agency.displayName || campaign.agency.title"
          :packageTitle="campaign.package.title"
          :property="campaign.property ? campaign.property.title : 'N/A'"
          :bookedBy="campaign.bookedBy ? campaign.bookedBy.firstName + ' ' + campaign.bookedBy.lastName : null"
          :bookedAt="campaign.createdAt"
          :startDate="campaign.startDate"
          :endDate="campaign.endDate"
          :status="campaign.status"
          :signifiOrderResponse="campaign.signifiOrderResponse"
          :signifiProductResponse="campaign.signifiProductResponse"
          :associatedCampaignId="campaign.associatedCampaignId"
          :type="campaign.type"
          :facebookPreview="campaign.signifiPreviewFacebookIframe"
          @on-campaign-updated="handleOnUpdated()"
        ></campaign-display>
      </div>
    </div>
  </div>
</template>
<script>
import CampaignDisplay from '../../../components/CampaignTools/CampaignDisplay.vue';
import CampaignIdSearch from '../../../components/CampaignTools/CampaignIdSearch.vue';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import NavigationPerimeters from '../../../configs/Perimeters/navigation';

export default {
  data() {
    return {
      campaign: null,
    };
  },
  components: {
    CampaignDisplay,
    CampaignIdSearch,
  },
  computed: {
    showPage() {
      return NavigationPerimeters.isAllowed('useAdminTool');
    },
  },
  methods: {
    async handleOnUpdated() {
      const response = await CampaignServiceV2.getAdminCampaign(
        this.campaign.id
      );
      if (response.data && response.data.data) {
        this.campaign = response.data.data;
      }
    },
    handleCampaignFound(campaign) {
      this.campaign = campaign;
    },
    handleOnSearch() {
      this.campaign = null;
    },
  },
};
</script>
